
define('jst!tooltips/_presence',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class=\'presence-tooltip\'>\n  <div class=\'name\'><%=data.contactName %></div>\n  <div class=\'online-indicator\'>\n    <div class=\'<%= data.stateStatus %>\'></div>\n    <% if (!_.isEmpty(data.stateStatusText)) { %>\n      <%= \' \'+data.stateStatusText %>\n    <% } %>\n  </div>\n</div>');
 });

